/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Calibration_Temperature_Error_CorrectionInputs */



/**
* | output |
* | --- |
* | "Calibration impossible if at least one th. head does not correct or in absence, frost-free or summer mode" |
*
* @param {Calibration_Temperature_Error_CorrectionInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const calibration_temperature_error_correction = /** @type {((inputs?: Calibration_Temperature_Error_CorrectionInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Calibration_Temperature_Error_CorrectionInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Calibration impossible if at least one th. head does not correct or in absence, frost-free or summer mode")
	return /** @type {LocalizedString} */ ("Calibrage impossible si au moins une des têtes th. ne corrige pas ou en absence, hors-gel ou mode été")
});